// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import materielProfileLayout from './MaterielProfileLayout';

import MaterielService from '../../services/MaterielService';

const DeleteMateriel = () => {
	const [materiel, setMateriel] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([MaterielService.getMateriel(id)]).then(([materielData]) => {
			setMateriel(materielData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the MaterielService to delete the Materiel
			await MaterielService.deleteMateriel(id);

			// Redirect the user to the list of Materiels
			navigate('/assets/materiels');
		} catch (error) {
			console.error(
				"Erreur lors de la suppression du materiel ",
				error
			);
		}
	};

	return (
		<materielProfileLayout>
			{materiel && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">{materiel.nom || ''}</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement ce materiel.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez ce mateirel, toutes les données le concernant seront
									définitivement perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer le materiel
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</materielProfileLayout>
	);
};

export default DeleteMateriel;
